__turbopack_context__.v({
  "dot": "Loading-module__GzkSZq__dot",
  "loader": "Loading-module__GzkSZq__loader",
  "slide": "Loading-module__GzkSZq__slide",
  "slideSimple": "Loading-module__GzkSZq__slideSimple",
  "tag": "Loading-module__GzkSZq__tag",
  "wrapper": "Loading-module__GzkSZq__wrapper",
});
